import type { NaturalDimensionsMaybe } from '../editor/types/aspectRatio';

export async function getImageNaturalDimensions(
  src: string,
): Promise<NaturalDimensionsMaybe> {
  return new Promise(resolve => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      console.error('Failed to load the image for src', src);
      resolve(null);
    };
  });
}

export async function getVideoNaturalDimensions(
  src: string,
): Promise<NaturalDimensionsMaybe> {
  return new Promise(resolve => {
    const video = document.createElement('video');
    video.src = src;
    video.preload = 'metadata'; // Only load metadata, not the entire video
    video.onloadedmetadata = () => {
      // Audio-only media in a video element (PLAT-11228 audio-first editing)
      // reports 0×0 — treat it as "no natural dimensions" rather than letting
      // callers divide by zero and bake NaN into layout props.
      if (!video.videoWidth || !video.videoHeight) {
        resolve(null);
        return;
      }
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
      });
    };
    video.onerror = () => {
      console.error('Failed to load video metadata for element', src);
      resolve(null);
    };
  });
}
